import { Exclude, Type } from "class-transformer";
import { getShopItemCategoryI18N } from "../utils/itemcategories";

export class ShopItem {
    _id?: string;

    name: string;
    materialNumber: string;
    category: CategoryType;
    maximumOrder?: number;
    inactive?: boolean;

    version?: number;

    @Type(() => Date)
    @Exclude({ toPlainOnly: true })
    created?: Date;

    @Type(() => Date)
    @Exclude({ toPlainOnly: true })
    updated?: Date;

    public getCategoryI18N(): string {
        return getShopItemCategoryI18N(this.category);
    }
}

export type CategoryType = "POS_MATERIALIEN" | "GIVE_AWAYS";
export const CategoryTypeArray: CategoryType[] = ["POS_MATERIALIEN", "GIVE_AWAYS"];
